// extracted by mini-css-extract-plugin
export var description = "index-module--description--24d39";
export var download = "index-module--download--8097f";
export var downloads = "index-module--downloads--9cc5d";
export var fullWidth = "index-module--fullWidth--7f9ba";
export var icon = "index-module--icon--f5401";
export var link = "index-module--link--d333d";
export var list = "index-module--list--bd791";
export var listItem = "index-module--listItem--20a78";